<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :loading="loading"
    :pageLoading="pageLoading"
    :table-headers="tableHeaders"
    :table-items="nfes"
    :maskFields="maskFields"
    :indexErrors="indexErrors"
    @clear-index-errors="indexErrors = []"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    @filter-confirm-action="applyFilters"
    :changeSwitch="changeSwitch"
    id="nfesPrintTable"
  >

  <template slot="link1" slot-scope="{ item }">
      <v-tooltip top >
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            link
            v-on="{ ...tooltip }"
            :to= "'/app/sales?nfeId=' + item.id"
          >
            <v-badge
              :content="item.cashFlows.length"
              :value="item.cashFlows.length"
              color="green"
              overlap
              offset-x="8"
              offset-y="8"
            >
              <v-icon>mdi-file-certificate</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <span>Visualizar Venda{{item.cashFlows.length > 1 ? 's' : ''}}</span>
      </v-tooltip>     
    </template>

    <template slot="filterText1">
        <v-card style="margin: 10px;">
          <v-text-field
            style="padding: 16px 16px;"
            v-model="products"
            label="Filtro por Produtos"
            >
          </v-text-field>
        </v-card>
    </template>

    <template slot="print">
        <BasePrint
          printableElementId="nfesPrintTable"
          printButtonLabel="Imprimir"
          printTitle="Notas fiscais eletrônicas do produtor"
          @start-printing="printing = loading = true"
          @stop-printing="printing = loading = false"
        />
    </template>

    <!-- <template v-if="item.cashFlows.length == 1" slot="link2" slot-scope="{ item }">
      <SaleEdit
        :entry="item.cashFlow"
        @entry-updated="entryUpdated"
        :editTitle="'Visualizar Venda ' + item.cashFlow.code"
        editIcon="mdi-handshake"
        :readOnly="item.statusKey == 'processing' || item.statusKey == 'sending' || item.statusKey == 'waiting_for_response' || item.statusKey == 'authorized'"
        :isTextButton="false"
        :readIcon="readIcon"
        :textButton="'Venda ' + item.cashFlow.code"
        modelNameSingular="Venda"
      />
    </template> -->

    <template slot="new" v-if="$route.query.saleId">
      <v-btn
        @click="redirectToNfes()"
        class="mt-3"
      >
        Ver todas as NF-es
      </v-btn>
    </template>

    <template v-if="item.canBeReissued" slot="edit" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <!-- Exibe mensagem com erro ou confirmacao -->
    <template v-if="item.nsXmotivo" slot="action1" slot-scope="{ item }">
      <v-tooltip top :color="item.statusKey == 'authorized' ? 'success' : item.statusKey == 'canceled' ? 'warning' : 'error'">
        <template v-slot:activator="{ on }">
          <v-icon
            :color="item.statusKey == 'authorized' ? 'success' : item.statusKey == 'canceled' ? 'warning' : 'error'"
            dark
            v-on="on"
            class="mx-1">
            {{item.statusKey == 'authorized' ? 'mdi-file-check' : item.statusKey == 'canceled' ? 'mdi-file-cancel' : 'mdi-alert'}}
          </v-icon>
        </template>
        <span>{{item.nsXmotivo}}</span>
      </v-tooltip>
    </template>


    <template v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'sending' || item.statusKey == 'waiting_for_response' || item.statusKey == 'retrieving_status_failed'" slot="action2" slot-scope="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-on="{ ...tooltip}"
            class="mx-1"
            @click="refreshNfeStatus(item)"
          >
            mdi-refresh
          </v-icon>
        </template>
        <span>Atualizar Status da emissão da NF-e</span>
      </v-tooltip>
    </template>

    <template v-if="item.statusKey == 'authorized' || item.statusKey == 'canceled'" slot="action3" slot-scope="{ item }">
      <BasePdfViewer v-if="item.statusKey == 'authorized' && item.type == 'NFPE'"
        :pdfSource="item.pdf"
        :loading="false"
        :pdfTitle="'NF-e-' + item.series + '-' + item.number"
        @pdf-open-action="getNfePdf(item, function() {return null;})"
        ref="nfePdfRef"
      />
      <BasePdfViewer v-if="item.statusKey == 'canceled'"
        :pdfSource="item.pdf"
        :loading="false"
        pdfTitle="Danfe de Cancelamento"
        @pdf-open-action="getNfeCancellationPdf(item, function() {return null;})"
        ref="nfeCancellationPdfRef"
      />
    </template>

    <template slot="new" v-if="nfeIds.length>0 && $can('read', 'OutboundMdfe')" slot-scope="{ item }">
      <MDFeNew
        :nfeIds="nfeIds"
        :inlineAddButton="false"
        modelNameSingular="MDF-e">
      </MDFeNew>
    </template>

    <!-- <template v-if="item.statusKey == 'authorized'" slot="action4" slot-scope="{ item }">
      <MDFeNew
        :nfeIds="nfeIds"
        :inlineAddButton="true"
        modelNameSingular="MDF-e">
      </MDFeNew>
    </template> -->

    <template v-if="item.statusKey == 'authorized' || item.statusKey == 'canceled'" slot="action5" slot-scope="{ item }">
      <BaseXmlViewer v-if="item.statusKey == 'authorized' && item.type == 'NFPE'"
        :xmlSource="item.xml"
        :loading="false"
        :xmlTitle="'NF-e-' + item.series + '-' + item.number"
        @xml-open-action="getNfeXml(item, function() {return null;})"
        ref="nfeXmlRef"
      />
      
      <BaseXmlViewer v-if="item.statusKey == 'canceled'"
        :xmlSource="item.xml"
        :loading="false"
        xmlTitle="Danfe XML de Cancelamento"
        @xml-open-action="getNfeCancellationXml(item, function() {return null;})"
        ref="nfeCancellationXmlRef"
      />
    </template>



    <template v-if="$can('update', $router.currentRoute.name) && item.statusKey == 'authorized'" slot="action7" slot-scope="{ item }">
      <!-- Delete was used to cancel the NFe -->
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="action10" v-if="item.statusKey == 'authorized'" slot-scope="{ item }">
      <cce
        :nfe="item"
      />
    </template>

    <template slot="action11" slot-scope="{ item }">
      <cce_index
        :nfe="item"
      />
    </template>

    <template slot="action12" slot-scope="{ item }">
      <v-tooltip top color="primary" >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-on="{ ...tooltip }"
            class="mx-1"
            @click="sendNfByEmail(item)"
            color="primary"
          >
            mdi-email
          </v-icon>
        </template>
        <span>Enviar PDF por e-mail</span>
      </v-tooltip>
    </template>

    <template slot="action13" slot-scope="{ item }">
      <v-tooltip top color="warning" >
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-on="{ ...tooltip }"
            class="mx-1"
            @click="sendNfByEmailToClient(item)"
            color="warning"
          >
            mdi-email
          </v-icon>
        </template>
        <span>Reenviar PDF para cliente</span>
      </v-tooltip>
    </template>


    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="6" class="text-right"><strong class="title mx-3">Total: </strong></td>
        <td colspan="2" class="text-left title"><strong>{{ this.totalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total:</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.totalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>

</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import BasePdfViewer from "@shared_components/base_pdf_viewer.vue";
import BaseXmlViewer from "@shared_components/base_xml_viewer.vue";
import BasePrint from "@shared_components/base_print.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";
import SaleEdit from "@models/sales/edit.vue";
import cce from "./cces/new.vue";
import cce_index from "./cces/index_form.vue";
import MDFeNew from "@models/fiscal_documents/outbounds/mdfes/new.vue";

export default {
  data() {
    return {
      nfes: [],
      statusRequests: 0,
      loading: true,
      pageLoading: false,
      indexErrors: [],
      totalPrice: null,
      totalItems: 0,
      products: null,
      nfeIds: [],
      tableHeaders: [
        { text: "Código", align: "left", sortable: true, value: "code" },
        { text: "Série",align: "left", sortable: true, value: "series" },
        { text: "Número", align: "left", sortable: true, value: "number" },
        { text: "Emitente", align: "left", sortable: true, value: "issuerName" },
        { text: "Cliente", align: "left", sortable: true, value: "customerName" },
        { text: "CFOP", align: "left", sortable: true, value: "cfop.code" },
        { text: "Emitido em", align: "left", sortable: true, value: "issueDate" },
        { text: "Valor", align: "left", sortable: true, value: "vNf" },
        { text: "Status", align: "left", sortable: true, value: "status", filter_value: "status" },
        { text: "Venda", align: "left", sortable: false, value: "link" },
        // { text: "Produtos", align: "left", sortable: false, value: "produtos" },
        { text: "Selecionado", align: "left", sortable: false, value: "selected"},
        // { text: "Tipo", align: "left", sortable: false, value: "type" },
        { text: "Ações", align: "left", sortable: false, value: "action" }
      ],
      maskFields: [
        { field: 'issueDate', mask: 'date' },
        { field: 'vNf', mask: 'currency' },
        { field: 'series', mask: 'nfe_serie' },
        { field: 'number', mask: 'nfe_number' },
        { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["code"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [],
      typeOperators: [],
      serverFields: [],
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "NFP-e"
    },
    modelNamePlural: {
      type: String,
      default: "NFP-es"
    },
    readIcon: {
      type: String,
      default: "mdi",
    },
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
    BasePdfViewer: BasePdfViewer,
    BaseXmlViewer: BaseXmlViewer,
    SaleEdit: SaleEdit,
    BasePrint: BasePrint,
    cce: cce,
    cce_index: cce_index,
    MDFeNew: MDFeNew
  },
  created() {
    // console.log(this.$router.currentRoute.name);
    // this.loadServerEntries();
  },
  watch: {
    "products": function(newSearch) {
      if (this.products && this.products.length > 0) {
        if (newSearch.length >= 3) {
          if(this.timer){
            clearTimeout(this.timer);
          }
          this.timer = setTimeout( ()=> {
            // console.log("newSearch", newSearch); 
            this.loadServerEntries();
          }, 2000);
        }
      }else{
        if(this.timer){
          clearTimeout(this.timer);
        }
        this.loadServerEntries();
      }
    },
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      let route = this.$route;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_ALL_NFES,
          variables: {
            input: {
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.value),
              filters: this.filters,
              customFilters: {produtos: this.products},
            },
            saleId: route.query.saleId ? route.query.saleId : null
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // if (route.query.saleId) {
          //   this.allNfes = response.data.accountContext.nfesIndex.nfes;
          //   this.nfes = _.filter(this.allNfes, function(nfe) {
          //     return nfe.cashFlow.id == route.query.saleId;
          //   });
          // } else {
          this.nfes = response.data.accountContext.nfesIndex.nfeViewIndexFilters;
          console.log("nfes", this.nfes);

          this.totalItems = response.data.accountContext.nfesIndex.count;
          this.typeOperators = response.data.accountContext.nfesIndex.typeOperators;
          this.serverFields = response.data.accountContext.nfesIndex.serverFields;

          this.totalPrice = 0;
          for (var nfe in this.nfes) {
            this.totalPrice += this.nfes[nfe].vNf;
          }
          this.totalPrice = _.round(this.totalPrice, 2);

          // console.log(this.totalItems, this.typeOperators, this.serverFields)
          // }
          // console.log("All NFEs", this.nfes);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    changeSwitch(item){
      if (item.selected == false){
        this.nfeIds = this.nfeIds.filter(function(id){
          return id !== item.id;
        });
      }else{
        this.nfeIds.push(item.id);
      }
      console.log(this.nfeIds);
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("NF-e reenviada com sucesso!");
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("NF-e enviada com sucesso!");
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationMessage("Cancelamento da NF-e enviado com sucesso!");
    },
    redirectToNfes: function() {
      this.$router.push({ name: "OutboundNfe"});
      this.nfes = this.allNfes;
      this.loadServerEntries();
    },
    refreshNfeStatus: function(nfe) {
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: UPDATE_NFE_STATUS_MUTATION,
          variables: {
            input: {
              nfpeId: nfe.id
            }
          },
        })
        .then(response => {
          //console.log(response.data.retrieveNfpeStatus)
          let errors = response.data.retrieveNfpeStatus.errors;
          if (errors.length){
            // this.$refs.baseIndex.showErrorMessage(errors);
            this.$set(this, 'indexErrors', errors);
            // this.indexErrors = errors;
          } else {
            var response_nfe = response.data.retrieveNfpeStatus.nfpe;
            if (response_nfe) {
              nfe.status = response_nfe.status;
              nfe.statusKey = response_nfe.statusKey;
              nfe.nsXmotivo = response_nfe.nsXmotivo;
            } else {
              this.$set(this, 'indexErrors', ["Não foi possível consultar o status. Tente novamente mais tarde."]);
            }
          }

        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfePdf: function(nfe, fileName) {
      this.getNfePdf(nfe, function(pdfFile){
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfePdf: function(nfe, callback) {
      if (nfe.pdf) {
        callback(nfe.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFE_PDF_MUTATION,
          variables: {
            nfpeId: nfe.id
          },
        })
        .then(response => {
          var response_data="";
          response_data = response.data.downloadNfpePdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0){
            this.indexErrors = errors;
            this.$refs.nfePdfRef.closeDialog();
          } else {
            let pdfFile = "data:application/octet-stream;base64," + response_data.nfpe.nfePdf
            this.$set(nfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeCancellationPdf: function(nfe, fileName) {
      this.getNfeCancellationPdf(nfe, function(pdfFile){
        const downloadLink = document.createElement("a");
        downloadLink.href = pdfFile;
        downloadLink.download = fileName + '.pdf';
        downloadLink.click();
      });
    },
    getNfeCancellationPdf: function(nfe, callback) {
      if (nfe.pdf) {
        callback(nfe.pdf);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFE_CANCELLATION_PDF_MUTATION,
          variables: {
            nfpeId: nfe.id
          },
        })
        .then(response => {
          var response_data = "";
          response_data = response.data.downloadNfpeCancellationPdf;
          var errors = response_data.errors
          // console.log(errors)
          if (errors.length > 0){
            this.indexErrors = errors;
            this.$refs.nfeCancellationPdfRef.closeDialog();
          } else {            
            let pdfFile = "data:application/octet-stream;base64," + response_data.nfpe.nfeCancellationPdf;
            this.$set(nfe, 'pdf', pdfFile);
            callback(pdfFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeXml: function(nfe, fileName) {
      this.getNfeXml(nfe, function(xmlString){
        let bb = new Blob([xmlString], {type: 'text/plain'});
        let xmlFile = window.URL.createObjectURL(bb);
        const downloadLink = document.createElement("a");
        downloadLink.href = xmlFile;
        downloadLink.download = fileName + '.xml';
        downloadLink.click();
      });
    },
    getNfeXml: function(nfe, callback) {
      // console.log("chamou XML");
      if (nfe.pdf) {
        callback(nfe.xml);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFE_XML_MUTATION,
          variables: {
            nfpeId: nfe.id
          },
        })
        .then(response => {
          var errors = response.data.downloadNfpeXml.errors;
          // console.log(errors)
          if (errors.length){
            this.indexErrors = errors;
            this.$refs.nfeXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadNfpeXml.nfpe.nfeXml;
            this.$set(nfe, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    downloadNfeCancellationXml: function(nfe, fileName) {
      this.getNfeCancellationXml(nfe, function(xmlString){
        let bb = new Blob([xmlString], {type: 'text/plain'});
        let xmlFile = window.URL.createObjectURL(bb);
        const downloadLink = document.createElement("a");
        downloadLink.href = xmlFile;
        downloadLink.download = fileName + '.xml';
        downloadLink.click();
      });
    },
    getNfeCancellationXml: function(nfe, callback) {
      // console.log("chamou XML");
      if (nfe.pdf) {
        callback(nfe.xml);
      }
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: DOWNLOAD_NFE_CANCELLATION_XML_MUTATION,
          variables: {
            nfpeId: nfe.id
          },
        })
        .then(response => {
          var errors = response.data.downloadNfpeCancellationXml.errors
          // console.log(errors)
          if (errors.length){
            this.indexErrors = errors;
            this.$refs.nfeCancellationXmlRef.closeDialog();
          } else {
            let xmlFile = response.data.downloadNfpeCancellationXml.nfpe.nfeCancellationXml;
            this.$set(nfe, 'xml', xmlFile);
            callback(xmlFile);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    sendNfByEmail: function(nfe) {
      this.pageLoading = true;

      this.$apollo
        .mutate({
          mutation: SEND_NFE_BY_EMAIL_MUTATION,
          variables: {
            id: nfe.id
          },
        })
        .then(response => {
          var errors = response.data.sendNfeByEmail.errors;
          // console.log(errors)
          if (errors.length){
            this.indexErrors = errors;
            // this.$refs.baseIndex.showErrorMessage();
          } else {
            this.$refs.baseIndex.showConfirmationMessage("PDF enviado com sucesso para o seu e-mail.");
          }
        })
        .catch(error => {
          console.log("error", error);
        })
        .finally(() => (this.pageLoading = false));
    },
    sendNfByEmailToClient: function(nfe) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: SEND_NFE_BY_EMAIL_TO_CLIENT_MUTATION,
          variables: {
            id: nfe.id
          },
        })
        .then(response => {
          var errors = response.data.sendNfeByEmailToClient.errors;
          // console.log(errors)
          if (errors.length){
            this.indexErrors = errors;
            // this.$refs.baseIndex.showErrorMessage();
          } else {
            this.$refs.baseIndex.showConfirmationMessage("PDF enviado");
          }
        })
        .catch(error => {
          console.log("error", error);
        })
        .finally(() => (this.pageLoading = false));
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    }
  }
};

const LOAD_ALL_NFES = gql `
  query($input: IndexInputObject!, $saleId: ID) {
  	accountContext {
      nfesIndex(input: $input, saleId: $saleId) {
        count
        nfeViewIndexFilters {
          id
          code
          series
          number
          selected
          hasMdfe
          produtos
          type
          cfopId
          cfop {
            text
            code
            description
          }
          issuerName
          status
          statusKey
          statusValue
          statusText
          statusColor
          deliveredReceivedDate
          deliveredReceivedTime
          issueDate
          issueTime
          mailingList
          nsXmotivo
          vNf
          canBeReissued
          customerName
          cashFlow {
            id
            code
            customer {
              id
              name
            }
          }
          cashFlows{
            id
            code
            customer{
              id
              name
            }
          }
        }
        serverFields
        typeOperators
      }
    }
  }
`;

const UPDATE_NFE_STATUS_MUTATION = gql `
  mutation($input: RetrieveNfpeStatusInputObject!) {
    retrieveNfpeStatus(input: $input) {
      nfpe {
        id
        status
        statusKey
        statusValue
        statusColor
        nsXmotivo
      }
      errors
    }
  }
`;

const DOWNLOAD_NFE_PDF_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpePdf(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfePdf
      }
      errors
    }
  }
`;


const DOWNLOAD_NFE_XML_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpeXml(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeXml
      }
      errors
    }
  }
`;

const DOWNLOAD_NFE_CANCELLATION_PDF_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpeCancellationPdf(
      input: {
        nfpeId: $nfpeId
    }) {
      nfpe{
        nfeCancellationPdf
      }
      errors
    }
  }
`;

const DOWNLOAD_NFE_CANCELLATION_XML_MUTATION = gql `
  mutation($nfpeId: ID!){
    downloadNfpeCancellationXml(input: { nfpeId: $nfpeId}) {
      nfpe{
        nfeCancellationXml
      }
      errors
    }
  }
`;

const SEND_NFE_BY_EMAIL_MUTATION = gql `
  mutation($id: ID!){
    sendNfeByEmail(
        id: $id
    ) {
      success
      errors
    }
  }
`;

const SEND_NFE_BY_EMAIL_TO_CLIENT_MUTATION = gql `
  mutation($id: ID!){
    sendNfeByEmailToClient(
        id: $id
    ) {
      success
      errors
    }
  }
`;


</script>

<style scoped></style>
